const configuration = {
    redirectSigninPath: '/auth/signin/interactive/callback',
    redirectSilentSigninPath: '/auth/signin/silent/callback',
    redirectUriAfterLogoutPath: '',
};

export default configuration;